export default __webpack_public_path__ + "static/media/landrover.7e5ef8aa.png";